
import OverlayDetails from './OverlayDetails'

export default {
  name: 'OverlayDetailsModal',
  components: { OverlayDetails },
  props: {
    value: Boolean,
    themeId: {
      type: [String, Number, Object],
      default: 0
    }
  },
  data () {
    return {
      theme: null
    }
  },
  watch: {
    themeId () {
      this.updateTheme()
    },
    value () {
      if (this.value) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'unset'
      }
    }
  },
  created () {
    this.updateTheme()
  },
  methods: {
    updateTheme () {
      if (!this.themeId) {
        return
      } else if (typeof this.themeId === 'object') {
        this.theme = this.themeId

        return
      }

      this.$axios
        .get(`v1/themes/${this.themeId}/`, { xhrLoader: true })
        .then((response) => {
          if (response && response.data) {
            this.theme = response.data
          }
        })
        .catch(() => this.close())
    },
    close (event) {
      if (event && event.target !== this.$refs.backdrop) {
        return
      }

      this.theme = null
      this.$emit('input', false)
    }
  }
}
